import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
  BarController,
  registerables as registerablesJS
} from 'chart.js';
import { Chart } from "react-chartjs-2"; // eslint-disable-line
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  LineController,
  BarController,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 0,
      bottom: 0
    }
  },
  plugins: {
    legend: {
      position: 'top',
      align: 'start',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 10,  // Reduced from 20 to 10
        color: '#333',
        font: {
          size: 12,
        }
      }
    },
    title: {
      display: true,
      text: 'Sessions',
      color: '#333',
      font: {
        size: 16,
        weight: 'bold'
      },
      padding: {
        top: 0,
        bottom: 5  // Reduced from 10 to 5
      },
      align: 'start'
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleColor: '#fff',
      bodyColor: '#fff',
      titleFont: {
        size: 14,
      },
      bodyFont: {
        size: 12,
      },
      padding: 10,
      cornerRadius: 4,
      mode: 'index',
      intersect: false,
      callbacks: {
        title: function(tooltipItems) {
          // Return the date (label) as the title
          return tooltipItems[0].label;
        },
        label: function(context) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          if (context.parsed.y !== null) {
            label += context.datasetIndex === 0 
              ? context.parsed.y.toFixed(2) + ' hr'
              : context.parsed.y;
          }
          return label;
        }
      },
      position: 'nearest',
      caretPadding: 10,
      caretSize: 0, // Hide the default caret
      positioner: (elements, eventPosition) => {
        if (!elements.length) {
          return false;
        }

        const { chart } = elements[0];
        const { left, right, top, bottom } = chart.chartArea;
        const { x, y } = eventPosition;
        
        let tooltipX = x;
        const tooltipY = y;
        const tooltipWidth = 200; // Estimate tooltip width, adjust as needed
        const padding = 10;

        // Adjust x-position if too close to the left edge
        if (x - tooltipWidth / 2 < left + padding) {
          tooltipX = left + padding + tooltipWidth / 2;
        }
        // Adjust x-position if too close to the right edge
        else if (x + tooltipWidth / 2 > right - padding) {
          tooltipX = right - padding - tooltipWidth / 2;
        }

        return {
          x: tooltipX,
          y: tooltipY
        };
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      ticks: {
        color: '#666',
        font: {
          size: 10,
        }
      }
    },
    y: {
      position: 'left',
      grid: {
        color: 'rgba(0, 0, 0, 0.1)'
      },
      ticks: {
        color: '#666',
        font: {
          size: 10,
        }
      }
    },
    y1: {
      position: 'right',
      grid: {
        display: false,
      },
      ticks: {
        color: '#666',
        font: {
          size: 10,
        }
      }
    }
  },
  barPercentage: 0.4, // Adjust this value to control bar width
  categoryPercentage: 0.6, // Adjust this to control spacing between bar groups
};

const colors = {
  line: '#05C5FD',
  bar: '#8718CF'
};

const LeftComboGraph = ({
  sessionsPerDate,
  sessionTimePerDate,
  reactVerbosity
}) => {
  // console.log('LeftComboGraph RENDERING');
  reactVerbosity === 2 &&
    console.log(
      '====> LeftComboGraph DATA:',
      sessionsPerDate,
      sessionTimePerDate
    );
  const labels = Object.keys(sessionsPerDate[0]);
  labels.sort((a, b) => {
    const aDate = new Date(a);
    const bDate = new Date(b);
    // console.log('a,b', aDate, bDate)
    return aDate - bDate;
  });
  const newSessionTimePerDate = labels.map((l) => {
    return sessionTimePerDate[l] / 60;
  });
  // console.log('=====> LABELS:', labels, sessionsPerDate, newSessionTimePerDate)
  const data = {
    labels,
    datasets: [
      {
        type: 'line',
        label: 'Session Time (hr)',
        data: newSessionTimePerDate,
        borderColor: colors.line,
        backgroundColor: colors.line,
        yAxisID: 'y',
        fill: false,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: colors.line,
        pointBorderColor: '#FFFFFF',
        pointBorderWidth: 2,
      },
      {
        type: 'bar',
        label: 'Sessions on Date',
        data: labels.map(label => sessionsPerDate[0][label]),
        borderColor: colors.bar,
        backgroundColor: colors.bar,
        yAxisID: 'y1',
        fill: true,
        borderWidth: 0,
        borderRadius: 0
      }
    ]
  };

  return (
    <div style={{ height: '360px', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
      <Chart type="bar" data={data} options={options} />
    </div>
  );
};

export default React.memo(LeftComboGraph);
